export function mapVehicleInfoToExchangeCar(vehicle) {
  return {
    Type: 'MARGE',
    LicensePlate: vehicle.licensePlate,
    Vin: vehicle.vin,
    BrandName: vehicle.brandCommercial || 'onbekend',
    ModelName: vehicle.model || 'onbekend',
    CommercialVehicle: vehicle.category !== 'Personenauto',
    Mileage: vehicle.odometerReading,
    ExchangeDate: null,
    ResidualBpm: null,
    Price: { Incl: 0, Excl: 0, Btw: 0, BtwRate: 0 },
    Bpm: { Value: vehicle.bpmAmount },
    TradeValue: null,
    Remark: null,
    ResidualBPMManualCalculation: null,
    CategoryCode: vehicle.categoryCode,
    VehicleType: vehicle.vehicleType,
    Trimline: vehicle.trimline,
    ExteriorColor: vehicle.exteriorColor,
    InteriorColor: vehicle.interiorColor,
    Engine: vehicle.engine,
    MotExpiryDate: vehicle.motExpiryDate,
    Licenseplate1AIssueing: vehicle.licenseplate1AIssueing,
    Licenseplate1BRegistration: vehicle.licenseplate1BRegistration,
    FirstRegistrationNL: vehicle.firstRegistrationNL,
    FirstRegistrationWorld: vehicle.firstRegistrationWorld,
  }
}

export function getUnknownExchangeCar(licensePlate) {
  return {
    Type: 'MARGE',
    LicensePlate: licensePlate,
    Vin: null,
    BrandName: 'onbekend',
    ModelName: 'onbekend',
    CommercialVehicle: false,
    Mileage: null,
    ExchangeDate: null,
    ResidualBpm: null,
    Price: { Incl: 0, Excl: 0, Btw: 0, BtwRate: 0 },
    Bpm: { Value: 0 },
    TradeValue: null,
    Remark: null,
    ResidualBPMManualCalculation: null,
    CategoryCode: null,
    VehicleType: null,
    Trimline: null,
    ExteriorColor: null,
    InteriorColor: null,
    Engine: null,
    MotExpiryDate: null,
    Licenseplate1AIssueing: null,
    Licenseplate1BRegistration: null,
    FirstRegistrationNL: null,
    FirstRegistrationWorld: null,
  }
}
